import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  headerlimit: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 28,
    paddingRight: 28,
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerPlaceProfil: {
    paddingTop: 0,
    paddingRight: 0,
  },
  headerImageHome: {
    width: 37,
    height: 56,
  },
  headerImageProfil: {
    width: 40,
    height: 40,
    marginLeft: 16,
    borderRadius: 25,
  },
  headerConnectLink: {
    flex: 1,
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignContent: 'center',
    flexDirection: 'row',
  },
  headerProfilText: {
    fontSize: 12,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerProfilTextSeparator: {
    marginRight: 10,
    marginLeft: 10,
    marginBottom: 4,
  },
});
